import Pagination from '@mui/material/Pagination';
import { Link, NavLink } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { newsCategoriesSelector, newsSelector } from "redux/selector"
import { NewsWrapper } from "./styled"
import { newsActions } from "redux/slice/newsSlice"
import Image from 'components/Image';
import Loading from 'components/Loading';
import { actionScrollToTop } from 'utils';


function News() {
    const navigate = useNavigate()
    const newsCategoryState = useSelector(newsCategoriesSelector)
    const newsState = useSelector(newsSelector)
    const location = useLocation();
    const queryPath = location.pathname;
    const myArray = queryPath.split("/");
    const slug = myArray[myArray.length - 1];
    const query = new URLSearchParams(location.search)
    const qPage = query.get("page")
    const [currentPage, setCurrentPage] = useState(qPage ? Number(qPage) : 1)
    const dispatch = useDispatch()


    useEffect(() => {
        dispatch(newsActions.getNewsByCategory({ slug, currentPage }))
    }, [currentPage, dispatch, slug])


    const handleChangePaginate = (event, pageNumber) => {
        setCurrentPage(pageNumber)
        navigate(`/news-category/${slug}?page=${pageNumber}`)
    }

    useEffect(() => {
        actionScrollToTop()
    }, [])

    return (
        <NewsWrapper>
            <div className='news container-fluid'>
                <div className='grid wide'>
                    {
                        newsCategoryState.newsCategoriesListAll.length > 0 &&
                        <ul className='news_category'>
                            {
                                newsCategoryState.newsCategoriesListAll.map(item => (
                                    <li className='news_category_item' key={item.id}
                                    >
                                        <NavLink
                                            className={({ isActive }) =>
                                                isActive ? "link_active" : "link_unactive"
                                            }
                                            to={`/news-category/${item.slug}`}>{item.name}</NavLink>
                                    </li>
                                ))
                            }
                        </ul>
                    }
                    <ul className='news_content'>
                        {
                            newsState.newsList.map(item => (
                                <li className='news_content_item' key={item.id}>
                                    <Link className='news_content_item_link' to={`/news/${item.slug}`}>
                                        <div className='news_content_item_thumbnail'>
                                            <Image src={item.thumbnail} alt='photos' />
                                        </div>
                                        <div className='news_content_item_description'>
                                            <h3 className='news_content_item_description_name'>{item.title}</h3>
                                            <p className='news_content_item_description_date'>{item.updated_at.slice(0, 10)}</p>
                                            <p className='news_content_item_description_post' dangerouslySetInnerHTML={{ __html: item.description }} />
                                        </div>
                                    </Link>
                                </li>
                            ))
                        }
                        {
                            !newsState.isFetching && newsState.newsList.length === 0 &&
                            <div className='news_content_empty'>
                                <p>Danh mục chưa có bài viết nào!</p>
                            </div>
                        }
                    </ul>
                    {
                        newsState.totalPage > 1 &&
                        <div className='news_pagination'>
                            <Pagination color="primary" count={newsState.totalPage} variant="outlined" shape="rounded"
                                onChange={(event, pageNumber) => handleChangePaginate(event, pageNumber)}
                                page={currentPage}
                            />
                        </div>
                    }
                    {
                        newsState.isFetching && <Loading />
                    }
                </div>
            </div>
        </NewsWrapper>
    );
}

export default News;
